/**
 * A run's outcome as four numbers (#2225).
 *
 * Extracted because two places on the Runs page now show it: the live card,
 * counting as tests land, and the detail pane for the selected run. Those are
 * the same four figures about the same run, a few hundred pixels apart, so
 * they cannot be allowed to disagree about what "skipped" means or which
 * colour "failed" is.
 *
 * Deliberately NOT shared with the print layout or the detailed-results view,
 * which render the same numbers under print constraints. One component across
 * both would need branching that neither call site wants.
 */
import type { TestRun } from '@/types'

export interface RunSummaryStatsProps {
  summary: NonNullable<TestRun['summary']>
}

export function RunSummaryStats({ summary }: RunSummaryStatsProps) {
  return (
    <div className="grid grid-cols-4 gap-3">
      <div className="text-center p-2.5 rounded-lg bg-muted">
        <div className="text-xl font-bold">{summary.total}</div>
        <div className="text-[10px] text-muted-foreground">Total</div>
      </div>
      <div className="text-center p-2.5 rounded-lg bg-success/10">
        <div className="text-xl font-bold text-success">{summary.passed}</div>
        <div className="text-[10px] text-success">Passed</div>
      </div>
      <div className="text-center p-2.5 rounded-lg bg-destructive/10">
        <div className="text-xl font-bold text-destructive">{summary.failed}</div>
        <div className="text-[10px] text-destructive">Failed</div>
      </div>
      <div className="text-center p-2.5 rounded-lg bg-muted">
        <div className="text-xl font-bold">{summary.skipped}</div>
        <div className="text-[10px] text-muted-foreground">Skipped</div>
      </div>
    </div>
  )
}
